import { SearchInput } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useCarrierContractListFilter } from './useCarrierContractListFilter';

export function SearchFilter() {
  const { search, setSearch } = useCarrierContractListFilter();
  const { t } = useTranslation();

  return (
    <SearchInput
      placeholder={t('carrierContracts.list.searchPlaceholder')}
      onChange={v => setSearch(v)}
      defaultValue={search}
    />
  );
}
